import {useMutation, useQueryClient} from "@tanstack/react-query";
import {toast} from "react-toastify";
import {deleteItem} from "../../../app/setters/deleteItem.js";

export const useUsunTag = () => {

    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (data) => deleteItem(`/rejestr/tag/${data.id}`),
        onError: () => {
            toast.error('Błąd podczas operacji')
        },

        onSettled: async () => {
            await queryClient.invalidateQueries({
                queryKey: ['tagi_lista'],
            });
        },

        onSuccess: ({message}) => {
            toast.success(message)
        }
    })
}